import { render } from "./huodongxq.vue?vue&type=template&id=479bd4cd&scoped=true"
import script from "./huodongxq.vue?vue&type=script&lang=js"
export * from "./huodongxq.vue?vue&type=script&lang=js"

import "./huodongxq.vue?vue&type=style&index=0&id=479bd4cd&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479bd4cd"]])

export default __exports__